import storage from 'good-storage';
// token
const USER_TOKEN_KEY = '__usertoken__'
// db登录账号的用户名
const DB_USER_REAL_NAME = '__dbUserRealName__'
// db模块访问权限
const DB_MODULE_PERMISSION = '__dbModulePermission__'
// xb模块发货方式权限（库存关闭：隐藏；库存开启：开启）
const XB_MODULESTORAGE = '__moduleStorage__'

// db操作权限
const DB_OPERATION_PERMISSION_KEY = '__dbOperationPermission__'

// db操作功能模块是否开启
const DB_MODULE_STATUS_PERMISSION = '__dbModuleStatusPermission__'

// db商品价格搜索条件选择隐藏
const DB_SELECT_HIDE = '__dbIsHideGoodsPriceSelectHide__'

// xb游客登录数据
const XB_GUEST_SETTING = '__xbGuestSetting__'

// xb页面基础信息
const XB_BASIC_INFORMATION = '__xbBasicInformation__'

// xb用户名
const XB_USER_NAME = '__xbUserName__'

// xb商城底部信息
const XB_SERVICE = '__xbService__'

// xb商城客服数据
const XB_CUSSERVICE = '__xbCusservice__'

//供应商用户账号信息
const SUPPLIER_USER = '__supplierUser__'

//供应商用户账号状态
const SUPPLIER_STATUS = '__supplierStatus__'

//供应商名
const SUPPLIER_NAME = '__supplierName__'

//供应商基础信息
const SUPPLIER_BASIC_INFORMATION = '__supplierBasicInfo__'

//XB收货地信息
const XB_RECEIVING_GOODS = '__xbReceivingGoods__'
//供应商商品修改权限
const SUPPLIER_GETMODIFY = '__supplierGetModify__'

//xb存放邀请码
const XB_PRON = "__inviteCode__";

//db活动列表信息
const DB_ACTIVITY_INFO = "__dbActivityInfo__";

//供应商活动列表信息
const SUPPLIER_ACTIVITY_INFO = "__supplierActivityInfo__";

//供应商标题和logo
const SUPPLIER_TITLE_INFO = "__supplierTitleInfo__";

//供应商商品入库
const SUPPLIER_STORAGE_IN = "__supplierStorageIn__";

//供应商库存编辑
const SUPPLIER_STORAGE_MODIFY = "__supplierStorageModify__";

//供应商库存编辑
const SUPPLIER_GOODS_DEL = "__supplierGoodsDel__";

//供应商商品上架
const SUPPLIER_GOODS_UP = "__supplierGoodsUp__";

//供应商商品下架
const SUPPLIER_GOODS_DOWN = "__supplierGoodsDown__";

//xb游客添加购物车时的商品数据
const XB_TOURIST_CART_GOODS = "__xbTouristCartGoods__";

function getToken() {
  // console.log('取token--', storage.get(USER_TOKEN_KEY))
  return storage.get(USER_TOKEN_KEY)
}

function saveToken(val) {
  // console.log('存token--')
  storage.set(USER_TOKEN_KEY, val)
}

function deleteToken() {
  // console.log('删除token--')
  storage.remove(USER_TOKEN_KEY)
}

function saveXbTouristCartGoods (val) {
  storage.set(XB_TOURIST_CART_GOODS, JSON.stringify(val))
}

function getXbTouristCartGoods() {
  if (storage.get(XB_TOURIST_CART_GOODS) !== undefined) {
    return JSON.parse(storage.get(XB_TOURIST_CART_GOODS))
  } else {
    return []
  }
}

function deleteXbTouristCartGoods() {
  storage.remove(XB_TOURIST_CART_GOODS)
}

function saveDBUserRealName(val) {
  storage.set(DB_USER_REAL_NAME, val)
}
function getDBUserRealName() {
  return storage.get(DB_USER_REAL_NAME)
}

function getDBModulePermission() {
  // console.log('获取db模块权限', storage.get(DB_MODULE_PERMISSION))
  return JSON.parse(storage.session.get(DB_MODULE_PERMISSION))
}

function saveDBModulePermission(val) {
  // console.log('存db模块权限')
  storage.session.set(DB_MODULE_PERMISSION, JSON.stringify(val))
}

function removeDBModulePermission() {
  // console.log('删除db权限--')
  storage.session.remove(DB_MODULE_PERMISSION)
}

function getDBOperationPermission() {
  // console.log('获取db权限', storage.get(DB_OPERATION_PERMISSION_KEY))
  if (storage.session.get(DB_OPERATION_PERMISSION_KEY)) {
    return JSON.parse(storage.session.get(DB_OPERATION_PERMISSION_KEY))
  } else {
    return ''
  }
  // return JSON.parse(storage.get(DB_OPERATION_PERMISSION_KEY) ? storage.get(DB_OPERATION_PERMISSION_KEY) : '{}')
}

function saveDBOperationPermission(val) {
  // console.log('存db权限')
  storage.session.set(DB_OPERATION_PERMISSION_KEY, JSON.stringify(val))
}

function removeDBOperationPermission() {
  // console.log('删除db权限--')
  storage.session.remove(DB_OPERATION_PERMISSION_KEY)
}

function saveDBModuleStatusPermission(val) {
  storage.set(DB_MODULE_STATUS_PERMISSION, JSON.stringify(val))
}

function getDBModuleStatusPermission() {
  return JSON.parse(storage.get(DB_MODULE_STATUS_PERMISSION))
}

function saveXBGuestSetting(val) {
  // console.log('存游客状态')
  storage.set(XB_GUEST_SETTING, JSON.stringify(val))
}
function getXBGuestSetting() {
  // console.log('获取游客状态')
  if (storage.get(XB_GUEST_SETTING)) {
    return JSON.parse(storage.get(XB_GUEST_SETTING))
  } else {
    return ''
  }
}

function removeXBGuestSetting() {
  // console.log('删除获取游客状态--')
  storage.remove(XB_GUEST_SETTING)
}

function saveXBBasicInformation(val) {
  // console.log('存页面基础信息')
  storage.session.set(XB_BASIC_INFORMATION, JSON.stringify(val))
}
function getXBBasicInformation() {
  // console.log('获取页面基础信息')
  if (storage.session.get(XB_BASIC_INFORMATION)) {
    return JSON.parse(storage.session.get(XB_BASIC_INFORMATION))
  } else {
    return ''
  }
}

// 存放供应商页面基础信息
function saveSupplierBasicInformation(val) {
  storage.session.set(SUPPLIER_BASIC_INFORMATION, JSON.stringify(val))
}
// 获取供应商页面基础信息
function getSupplierBasicInformation() {
  if (storage.session.get(SUPPLIER_BASIC_INFORMATION)) {
    return JSON.parse(storage.session.get(SUPPLIER_BASIC_INFORMATION))
  } else {
    return ''
  }
}

function saveXBUserName(val) {
  // console.log('存xb用户名')
  storage.set(XB_USER_NAME, JSON.stringify(val))
}
function getXBUserName() {
  // console.log('获取xb用户名')
  if (storage.get(XB_USER_NAME)) {
    return JSON.parse(storage.get(XB_USER_NAME))
  } else {
    return ''
  }
}
function removeXBUserName() {
  // console.log('删除xb用户名')
  storage.remove(XB_USER_NAME)
}

function saveXBService(val) {
  // console.log('存xb底部信息')
  storage.session.set(XB_SERVICE, JSON.stringify(val))
}
function getXBService() {
  if (storage.session.get(XB_SERVICE)) {
    return JSON.parse(storage.session.get(XB_SERVICE))
  } else {
    return ''
  }
}

function saveXBCusservice(val) {
  // console.log('存xb客服数据')
  storage.session.set(XB_CUSSERVICE, JSON.stringify(val))
}
function getXBCusservice() {
  // console.log('获取xb客服数据')
  if (storage.session.get(XB_CUSSERVICE)) {
    return JSON.parse(storage.session.get(XB_CUSSERVICE))
  } else {
    return ''
  }
}

function saveSupplierUser(data) {
  storage.set(SUPPLIER_USER, JSON.stringify(data))
}
function getSupplierUser() {
  if (storage.get(SUPPLIER_USER)) {
    return JSON.parse(storage.get(SUPPLIER_USER))
  } else {
    return {
      username: "",
      password: ""
    }
  }
}
function removeSupplierUser() {
  storage.remove(SUPPLIER_USER)
}

function saveSupplierStatus(val) {
  storage.set(SUPPLIER_STATUS, JSON.stringify(val))
}

function getSupplierStatus() {
  if (storage.get(SUPPLIER_STATUS)) {
    return JSON.parse(storage.get(SUPPLIER_STATUS))
  } else {
    return ""
  }
}

function saveGetModify(val) {
  // console.log('存商品修改权限')
  storage.session.set(SUPPLIER_GETMODIFY, JSON.stringify(val))
}
function getGetModify(val) {
  return storage.session.get(SUPPLIER_GETMODIFY)
}
function saveSupplierName(val) {
  storage.set(SUPPLIER_NAME, JSON.stringify(val))
}

function getSupplierName() {
  if (storage.get(SUPPLIER_NAME)) {
    return JSON.parse(storage.get(SUPPLIER_NAME))
  } else {
    return ''
  }
}

// 收货地信息
function saveXBReceivingGoodsAddressInfo(val) {
  storage.session.set(XB_RECEIVING_GOODS, JSON.stringify(val))
}

function getXBReceivingGoodsAddressInfo() {
  if (storage.session.get(XB_RECEIVING_GOODS)) {
    return JSON.parse(storage.session.get((XB_RECEIVING_GOODS)))
  } else {
    return ''
  }
}

function deleteXBReceivingGoodsAddressInfo() {
  storage.session.remove(XB_RECEIVING_GOODS)
}

// 存邀请码
function saveXBPron(val) {
  storage.set(XB_PRON, JSON.stringify(val));
}

// 获取邀请码
function getXBPron() {
  if (storage.get(XB_PRON)) {
    return JSON.parse(storage.get(XB_PRON));
  } else {
    return "";
  }
}
//删除邀请码
function removeXBPron() {
  storage.remove(XB_PRON)
}

function setActivityInfo(val) {
  // console.log('存db活动列表信息')
  storage.session.set(DB_ACTIVITY_INFO, JSON.stringify(val))
}
function getActivityInfo() {
  // console.log('获取db活动列表信息')
  if (storage.session.get(DB_ACTIVITY_INFO)) {
    return JSON.parse(storage.session.get(DB_ACTIVITY_INFO))
  } else {
    return ''
  }
}

function setSupplierActivityInfo(val) {
  // console.log('存供应商活动列表信息')
  storage.session.set(SUPPLIER_ACTIVITY_INFO, JSON.stringify(val))
}
function getSupplierActivityInfo() {
  // console.log('获取供应商活动列表信息')
  if (storage.session.get(SUPPLIER_ACTIVITY_INFO)) {
    return JSON.parse(storage.session.get(SUPPLIER_ACTIVITY_INFO))
  } else {
    return ''
  }
}

function setSupplierTitleInfo(val) {
  // console.log('存供应商logo和标题')
  storage.session.set(SUPPLIER_TITLE_INFO, JSON.stringify(val))
}
function getSupplierTitleInfo() {
  // console.log('获取供应商logo和标题')
  if (storage.session.get(SUPPLIER_TITLE_INFO)) {
    return JSON.parse(storage.session.get(SUPPLIER_TITLE_INFO))
  } else {
    return ''
  }
}

function saveStorageIn(val) {
  // console.log('存供应商商品入库')
  storage.session.set(SUPPLIER_STORAGE_IN, JSON.stringify(val))
}
function getStorageIn(val) {
  return storage.session.get(SUPPLIER_STORAGE_IN)
}

function saveStorageModify(val) {
  // console.log('存供应商库存编辑')
  storage.session.set(SUPPLIER_STORAGE_MODIFY, JSON.stringify(val))
}
function getStorageModify(val) {
  return storage.session.get(SUPPLIER_STORAGE_MODIFY)
}

function saveGoodsDel(val) {
  // console.log('存供应商商品删除')
  storage.set(SUPPLIER_GOODS_DEL, JSON.stringify(val))
}
function getGoodsDel() {
  return storage.get(SUPPLIER_GOODS_DEL)
}


function saveGoodsUp(val) {
  // console.log('存供应商商品上架')
  storage.set(SUPPLIER_GOODS_UP, JSON.stringify(val))
}

function getGoodsUp() {
  return storage.get(SUPPLIER_GOODS_UP)
}

function saveGoodsDown(val) {
  // console.log('存供应商商品下架')
  storage.set(SUPPLIER_GOODS_DOWN, JSON.stringify(val))
}

function getGoodsDown() {
  return storage.get(SUPPLIER_GOODS_DOWN)
}

function saveIsHideGoodsPriceSelectHide(val) {
  // console.log('存db商品价格搜索条件选择隐藏')
  storage.set(DB_SELECT_HIDE, JSON.stringify(val))
}
function getIsHideGoodsPriceSelectHide(val) {
  if (storage.get(DB_SELECT_HIDE)) {
    return JSON.parse(storage.get(DB_SELECT_HIDE))
  } else {
    return ''
  }
}

export {
  getToken,
  saveToken,
  deleteToken,
  saveDBUserRealName,
  getDBUserRealName,
  getDBModulePermission,
  saveDBModulePermission,
  removeDBModulePermission,
  getDBOperationPermission,
  saveDBOperationPermission,
  removeDBOperationPermission,
  saveDBModuleStatusPermission,
  getDBModuleStatusPermission,
  saveXBGuestSetting,
  getXBGuestSetting,
  removeXBGuestSetting,
  saveXBBasicInformation,
  getXBBasicInformation,
  saveXBUserName,
  getXBUserName,
  removeXBUserName,
  saveXBService,
  getXBService,
  saveXBCusservice,
  getXBCusservice,
  saveSupplierUser,
  getSupplierUser,
  removeSupplierUser,
  saveSupplierStatus,
  getSupplierStatus,
  saveSupplierName,
  getSupplierName,
  saveSupplierBasicInformation,
  getSupplierBasicInformation,
  saveXBReceivingGoodsAddressInfo,
  getXBReceivingGoodsAddressInfo,
  deleteXBReceivingGoodsAddressInfo,
  saveGetModify,
  getGetModify,
  saveXBPron,
  getXBPron,
  removeXBPron,
  setActivityInfo,
  getActivityInfo,
  setSupplierActivityInfo,
  getSupplierActivityInfo,
  setSupplierTitleInfo,
  getSupplierTitleInfo,
  saveXbTouristCartGoods,
  getXbTouristCartGoods,
  deleteXbTouristCartGoods,
  saveStorageIn,
  getStorageIn,
  saveStorageModify,
  getStorageModify,
  saveGoodsDel,
  getGoodsDel,
  saveGoodsUp,
  getGoodsUp,
  saveGoodsDown,
  getGoodsDown,
  saveIsHideGoodsPriceSelectHide,
  getIsHideGoodsPriceSelectHide
}
